export class Subscribable<T extends () => void> {
  protected listeners: Set<T>;

  constructor() {
    this.listeners = new Set();
    this.subscribe = this.subscribe.bind(this);
  }

  notify = () => {
    this.listeners.forEach((listener) => listener());
  };

  subscribe = (listener: T) => {
    this.listeners.add(listener);
    return () => this.listeners.delete(listener);
  };
}
